import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  logo: {
    height: "24px",
    verticalAlign: "middle",
    width: "24px",
  },
}));

export default useStyles;
